<template>
  <div class="mb-1 flex flex-row items-center pt-1.5 pr-2 pb-1.5 pl-2">
    <BaseIconButton icon="close" class="mr-2" @click="back()" />
    <div class="flex flex-col">
      <h2 class="text-title-large mr-4">Dialog mit {{ dialogWith.firstName }}</h2>
    </div>
    <div class="flex flex-row items-center px-4">
      <div
        v-if="dialog.phase === DialogPhase.Conversation"
        class="rounded-small text-label-large bg-primary text-on-primary group relative flex h-8 flex-row items-center justify-center gap-2 overflow-hidden px-3 whitespace-nowrap select-none"
      >
        <span>
          {{ $t('dialog.isRunning') }}
        </span>
        <span class="bg-on-primary animate-color-pulse h-2 w-2 rounded-full"></span>
      </div>
      <BaseChip v-else>{{ $t('dialog.phases.' + dialog.phase) }}</BaseChip>
      <div v-if="dialog.phase === DialogPhase.Conversation" class="ml-4 flex flex-row gap-1">
        <BaseMemberAvatar :member="dialog.coach" size="24" />
        <BaseMemberAvatar :member="dialog.coachee" size="24" />
      </div>
    </div>
    <div class="ml-auto flex flex-row items-center gap-1">
      <slot name="actions" />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import BaseIconButton from '../../../core/components/base/button/icon-button/BaseIconButton.vue'
  import { DialogPhase, type Dialog } from '../../../core/models/dialog/dialog'
  import { useUserStore } from '../../../stores/user.store'
  import BaseChip from '@/core/components/base/chip/BaseChip.vue'
  import BaseMemberAvatar from '@/core/components/base/avatar/BaseMemberAvatar.vue'

  interface Props {
    dialog: Dialog
  }

  const props = defineProps<Props>()

  const emits = defineEmits<{
    (e: 'close'): void
  }>()

  const { user } = useUserStore()

  const dialogWith = computed(() => {
    if (props.dialog.coach.id == user.id) {
      return props.dialog.coachee
    }
    return props.dialog.coach
  })

  const back = () => {
    emits('close')
  }
</script>
